class OnlineStatus {
  isOnline = navigator.onLine;

  constructor() {
    window.addEventListener('online', () => {
      this.isOnline = true;
    });

    window.addEventListener('offline', () => {
      this.isOnline = false;
    });
  }

  get() {
    return this.isOnline;
  }
}

export const onlineStatus = new OnlineStatus();
